import API_URL from "../../api/API";


export const enterEditMode = async (waiver, business) => {

  if (!waiver.isCreateWizardMode) {
    return true;
  }

  try {
    const res = await fetch(
      `${API_URL.BUSINESS_WAIVER_ENTER_EDIT_MODE}/${waiver._id}`,
      {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${business.token}`,
          "x-session-id": business.sessionId,
          "x-frontend-url": window.location.pathname,
        },
      }
    );

    const data = await res.json();

    if (!data.success) {
      throw new Error(data.message || "Failed to enter edit mode");
    }

    return true;
  } catch (err) {
    console.error(err);
    alert("Unable to open waiver for editing.");
    return false;
  }
};

/* The backend endpoint can simply 
call your setWizardModeAsFalse() helper. 
Since it only updates the document if isCreateWizardMode is still true, 
it's safe to call every time. */
